import { render, staticRenderFns } from "./RemoteCheckInForm.vue?vue&type=template&id=bbf2dd60&scoped=true"
import script from "./RemoteCheckInForm.vue?vue&type=script&lang=js"
export * from "./RemoteCheckInForm.vue?vue&type=script&lang=js"
import style0 from "./RemoteCheckInForm.vue?vue&type=style&index=0&id=bbf2dd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf2dd60",
  null
  
)

export default component.exports